import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import Button from "@material-ui/core/Button";
import Toolbar from "@mui/material/Toolbar";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import TableContainer from "@mui/material/TableContainer";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { downloadExcel } from "react-export-table-to-excel";
import { CSVLink, CSVDownload } from "react-csv";

// Modal Dialog
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import LinearProgress from '@mui/material/LinearProgress';

// Cards
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Autocomplete from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const token = localStorage.getItem("access_token");

const drawerWidth = 240;
var bgColors = {
    Default: "#81b71a",
    Blue: "#00B1E1",
    Cyan: "#37BC9B",
    Green: "#8CC152",
    Red: "#9e0000",
    Yellow: "#F6BB42",
};

const bulanlist = [
    {
        value: "1",
        label: "Januari",
    },
    {
        value: "2",
        label: "Februari",
    },
    {
        value: "3",
        label: "Maret",
    },
    {
        value: "4",
        label: "April",
    },
    {
        value: "5",
        label: "Mei",
    },
    {
        value: "6",
        label: "Juni",
    },
    {
        value: "7",
        label: "July",
    },
    {
        value: "8",
        label: "Agustus",
    },
    {
        value: "9",
        label: "September",
    },
    {
        value: "10",
        label: "Oktober",
    },
    {
        value: "11",
        label: "November",
    },
    {
        value: "12",
        label: "Desember",
    },
];

const tahunlist = [
    {
        value: "2018",
        label: "2018",
    },
    {
        value: "2019",
        label: "2019",
    },
    {
        value: "2020",
        label: "2020",
    },
    {
        value: "2021",
        label: "2021",
    },
    {
        value: "2022",
        label: "2022",
    },
    {
        value: "2023",
        label: "2023",
    },
];

const listPertanyaan = [
    {
        value: "Ya",
        label: "Ya",
    },
    {
        value: "Tidak",
        label: "Tidak",
    }
];

const useStyles = makeStyles((theme) => ({
    headerimage: {
        width: theme.spacing(10),
        height: theme.spacing(5),
    },
    thead: {
        backgroundColors: bgColors.Cyan,
    },
    btn: {
        marginTop: theme.spacing(2),
    },
    btnexport: {
        // marginLeft: theme.spacing(125),
        float: "right",
        marginBottom: theme.spacing(1),
        backgroundColors: bgColors.Green,
    },
    inputText: {
        width: "48%",
        marginLeft: theme.spacing(2)
    },
}));

function LdoSales(props) {
    let currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth();
    const [bulan, setBulan] = React.useState(month+1);
    const [tahun, setTahun] = React.useState(year);
    const [nmCustomer, setCustomer] = React.useState("");
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(25);
    const [loadingSet, setLoadingData] = useState(false);

    const queryOptions = React.useMemo(
        () => ({
            page,
            pageSize,
        }),
        [page, pageSize]
    );

    const handleChange = (event) => {
        setBulan(event.target.value);
    };
    const handleChange2 = (event) => {
        setTahun(event.target.value);
    };
    const handleCustomer = (event, value) => {
        const customername = value != null ? value.label : "";
        setCustomer(customername);
    };

    const isLoading = false;

    const [open, setOpen] = React.useState(false);
    const [dtDo, setDtDo] = React.useState([]);

    const handleClickOpen = (eventValue) => {
        setDtDo(eventValue);
        setInputs((values) => ({
            ...values,
            ["dtid"]: eventValue.id
        }));
        setOpen(true);
    };

    const [openCancel, setOpenCancel] = React.useState(false);
    const handleCancelBooking = (eventValue) => {
        setDtDo(eventValue);
        setOpenCancel(true);
        setInputsCancel((values) => ({
            ...values,
            ["id_pil"]: eventValue.id,
            ["cancel"]: "yes",
        }));
    };

    const handleClose = () => {
        setOpen(false);
        setOpenCancel(false);
        setInputs([]);
    };

    // API List Data Prospek
    const [dataCustomer, setDataCustomer] = useState([]);
    const [dataProspek, setDataProspek] = useState([]);
    const [dataProspek2, setDataProspek2] = useState([]);
    const [fullWidth, setFullWidth] = React.useState(true);
    const [refreshDt, setRefresh] = useState();

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        const getDataCustomer = async () => {
            const url = `https://api.aims.wijayatoyota.co.id/api/area/sales/list/data/do/customer`;
            try {
                const response = await axios.get(url);
                // if (response.statusText === "") {
                    setDataCustomer(response.data.data);
                // } else {
                //     throw new Error("Request failed");
                // }
            } catch (error) {
                console.log(error);
            }
        };
        getDataCustomer();
    }, []);

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        const getData = async () => {
            setLoadingData(true);
            const url = `https://api.aims.wijayatoyota.co.id/api/area/sales/list/showdata/do?customer=${nmCustomer}&page=${page}&size=${pageSize}`;
            try {
                const response = await axios.get(url);
                // if (response.statusText === "") {
                    setLoadingData(false);
                    setDataProspek(response.data.data);
                    setDataProspek2(response.data);
                // } else {
                //     throw new Error("Request failed");
                // }
            } catch (error) {
                console.log(error);
            }
        };
        getData();
    }, [page, pageSize, nmCustomer, refreshDt]);

    const handleClick = (values) => {
        console.log(values);
    };

    const [inputs, setInputs] = useState([]);
    const handleChangeInput = (event) => {
        setInputs((values) => ({
            ...values,
            [event.target.name]: event.target.value,
        }));
    };

    const [inputsCancel, setInputsCancel] = useState([]);
    const handleInputCancel = (event) => {
        setInputsCancel((values) => ({
            ...values,
            [event.target.name]: event.target.value,
        }));
    };
    
    const handleSubmit = (event) => {
        event.preventDefault();
        axios
            .put("https://api.aims.wijayatoyota.co.id/api/booking/action/updateTanggal", inputs)
            .then(function (response) {
                if (response.data.error == true) {
                    swal("Error", "Data tidak boleh kosong!", "error", {
                        buttons: false,
                        timer: 2000,
                    });
                } else {
                    swal("Success", "Data Berhasil disimpan!", "success", {
                        buttons: false,
                        timer: 2000,
                    });
                    // window.location.reload();
                    setOpen(false);
                    setRefresh(response);
                }
            });
    };

    const handleSubmitCancel = (event) => {
        event.preventDefault();
        axios
            .put("https://api.aims.wijayatoyota.co.id/api/booking/action/cancel", inputsCancel)
            .then(function (response) {
                if (response.data.error == true) {
                    swal("Error", "Data tidak boleh kosong!", "error", {
                        buttons: false,
                        timer: 2000,
                    });
                } else {
                    swal("Success", "Data Berhasil disimpan!", "success", {
                        buttons: false,
                        timer: 2000,
                    });
                    // window.location.reload();
                    setOpenCancel(false);
                    setRefresh(response);
                }
            });
    };

    const [rowCountState, setRowCountState] = React.useState(
        dataProspek2?.totalAll || 0
    );

    React.useEffect(() => {
        setRowCountState((prevRowCountState) =>
            dataProspek2?.totalAll !== undefined
                ? dataProspek2?.totalAll
                : prevRowCountState
        );
    }, [dataProspek2?.totalAll, setRowCountState]);

    const columns = [
        { field: 'tgl', headerName: "Tgl SPK", minWidth: 150 },
        { field: 'tgl_do', headerName: "Tgl DO", minWidth: 150 },
        { field: 'no_spk', headerName: "No SPK", minWidth: 150 },
        { field: 'nama_spv', headerName: "SPV", minWidth: 200 },
        { field: 'nama_sales', headerName: "Sales", minWidth: 200 },
        { field: 'nama_cust', headerName: "Customer", minWidth: 200 },
        { field: 'nama_stnk', headerName: "Nama STNK", minWidth: 200 },
        { field: 'kecamatan', headerName: "Kecamatan", minWidth: 200 },
        { field: 'kelurahan', headerName: "Kelurahan", minWidth: 200 },
        { field: 'telp', headerName: "Telp", minWidth: 200 },
        { field: 'tipe', headerName: "Tipe", minWidth: 200 },
        { field: 'warna', headerName: "Warna", minWidth: 200 },
        { field: 'kategori_sumber', headerName: "Kategori Sumber", minWidth: 200 },
        { field: 'sumber', headerName: "Sumber Prospek", minWidth: 200 },
        { field: 'leasing', headerName: "Leasing", minWidth: 200 },
        { field: 'crsatu', headerName: "CR 1", minWidth: 200 },
        { field: 'crdua', headerName: "CR 2", minWidth: 200 },
        { field: 'cek1000', headerName: "Cek 1000", minWidth: 200 },
        { field: 'feedback', headerName: "Feedback", minWidth: 200 },
        { field: 'hobby', headerName: "Hobby", minWidth: 200 },
        { field: 'ket', headerName: "Ket", minWidth: 200 },      
    ];
    return (
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                p: 3,
                width: { sm: `calc(100% - ${drawerWidth}px)` },
            }}
        >
            <Toolbar />
            <Typography>
                <b>List Data DO</b>
            </Typography>{" "}
            <br />
            <Box
                component="form"
                sx={{
                    "& .MuiTextField-root": { m: 1, width: "25ch" },
                }}
                noValidate
                autoComplete="off"
            >
                <div>
                    
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={dataCustomer}
                        onChange={handleCustomer}
                        renderInput={(params) => (
                            <TextField {...params} label="Customer" helperText="Pilih Customer" />
                        )}
                    />
                </div>
            </Box>
            <br></br>
            <Box style={{ width: "100%" }}>
                {loadingSet === true ? 
                    // <center><CircularProgress size="1.2rem" color="inherit" /></center>
                    <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                        <LinearProgress />
                    </Stack>
                :  
                    ""
                }
            </Box>
            <TableContainer style={{ height: 500, width: "100%" }}>
                <DataGrid
                    DataGrid
                    rows={dataProspek}
                    rowCount={rowCountState}
                    loading={isLoading}
                    components={{ Toolbar: GridToolbar }}
                    rowsPerPageOptions={[25, 50, 100]}
                    pagination
                    page={page}
                    pageSize={pageSize}
                    paginationMode="server"
                    onPageChange={(newPage) => setPage(newPage)}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    columns={columns}
                />
            </TableContainer>
            <br></br>
            <br></br>
            {/* {nmCustomer != "" ? (
                <Box sx={{ flexGrow: 1 }}>
                    {dataProspek.map((datval) => [
                        <Card key={datval.id} sx={{ width: "90%", margin: "0 auto", borderTop: "1px solid #e0e0e0", marginBottom: 2 }}>
                            <CardContent>
                                <Typography
                                    gutterBottom
                                    variant="h6"
                                    component="div"
                                >
                                    {datval.nama_cust}
                                </Typography>
                                <Typography
                                    sx={{ fontSize: 12 }}
                                >
                                    NO SPK <b>{datval.no_spk}</b><br></br>
                                    Tanggal SPK <b>{datval.tgl}</b><br></br>
                                    Tanggal DO <b>{datval.tgl_do}</b><br></br>
                                    {datval.alamat}, {datval.kecamatan}<br></br>
                                    <b>{datval.nama_stnk}, {datval.telp}</b><br></br>
                                    <b>{datval.tipe}, {datval.warna}</b><br></br>
                                    <b>{datval.kategori_sumber}, {datval.sumber}</b><br></br>
                                    <b>{datval.no_rangka}</b><br></br>
                                    <b>{datval.leasing}</b><br></br>
                                </Typography>
                            </CardContent>
                        </Card>
                        ,
                    ])}
                </Box>
            ) : (
                ""
            )} */}
            <Box style={{ width: "100%" }}>
                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    keepMounted
                    maxWidth="md"
                    fullWidth={fullWidth}
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Update Tanggal Booking"}</DialogTitle>
                    <DialogContent>
                        <Typography>
                            Nama Sales <b>{dtDo.sales}</b>
                            <br />
                            Nama Customer <b>{dtDo.customer}</b>
                            <br />
                            Alamat <b>{dtDo.alamat}</b>
                            <br />
                            No Polisi <b>{dtDo.nopol}</b>
                            <br />
                            No Rangka <b>{dtDo.no_rangka}</b>
                            <br />
                        </Typography>{" "}
                        <br />
                        <form>
                            <Box
                                style={{ width: "100%" }}
                                sx={{ marginBottom: 2 }}
                            >
                                <TextField
                                    id="outlined-basic"
                                    required
                                    variant="outlined"
                                    name="tanggalbooking"
                                    onChange={handleChangeInput}
                                    sx={{ width: "100%" }}
                                    size="small"
                                    type="date"
                                    helperText="Tanggal Booking"
                                />
                            </Box>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={handleSubmit}
                        >
                            Submit
                        </Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </Dialog>

                {/* Cancel Dialog */}
                <Dialog
                    open={openCancel}
                    TransitionComponent={Transition}
                    keepMounted
                    maxWidth="md"
                    fullWidth={fullWidth}
                    onClose={handleClose}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Cancel Booking"}</DialogTitle>
                    <DialogContent>
                        <Typography>
                            No SPK <b>{dtDo.no_spk}</b>
                            <br />
                            Nama Sales <b>{dtDo.nama_sales}</b>
                            <br />
                            Nama Customer <b>{dtDo.nama_cust}</b>
                            <br />
                            Alamat <b>{dtDo.alamat}</b>
                            <br />
                            No Rangka <b>{dtDo.no_rangka}</b>
                            <br />
                        </Typography>{" "}
                        <br />
                        <form>
                            <Box
                                style={{ width: "100%" }}
                                sx={{ marginBottom: 2 }}
                            >
                                <TextField
                                    id="outlined-basic"
                                    required
                                    variant="outlined"
                                    name="alasan_cancel"
                                    label="Alasan Cancel"
                                    onChange={handleInputCancel}
                                    sx={{ width: "100%" }}
                                    size="small"
                                    helperText="Alasan Cancel"
                                />
                            </Box>
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={handleSubmitCancel}
                        >
                            Submit
                        </Button>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
    );
}

export default LdoSales;

if (document.getElementById("listdatadosales")) {
    ReactDOM.render(<LdoSales />, document.getElementById("listdatadosales"));
}
